import { observer } from 'mobx-react-lite';
import { MerchantDto } from 'src/generated-api-client';
import { MerchantBusinessInfoCard } from 'src/pages/MerchantDetailsPage/components/MerchantBusinessInfoCard';
import { MerchantGeneralInfoCard } from 'src/pages/MerchantDetailsPage/components/MerchantGeneralInfoCard';
import { MerchantSalesCard } from 'src/pages/MerchantDetailsPage/components/MerchantSalesCard';

type MerchantGeneralInfoTabProps = {
    merchant?: MerchantDto;
};

export const MerchantGeneralInfoTab = observer(
    ({ merchant }: MerchantGeneralInfoTabProps) => {
        return (
            <>
                <MerchantGeneralInfoCard merchant={merchant} />
                <MerchantBusinessInfoCard merchant={merchant} />
                <MerchantSalesCard merchant={merchant} />
            </>
        );
    },
);
